import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  editField: {
    padding: '9px',
  },
  title: {
    color: theme.palette.text.disabled,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  clearButton: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
}));

export default useStyles;
